import { render, staticRenderFns } from "./ContactLens.vue?vue&type=template&id=2288f3a7&scoped=true&"
import script from "./ContactLens.vue?vue&type=script&lang=ts&"
export * from "./ContactLens.vue?vue&type=script&lang=ts&"
import style0 from "./ContactLens.vue?vue&type=style&index=0&id=2288f3a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2288f3a7",
  null
  
)

export default component.exports